<template>
  <div class="messageRecord">
    <div :class="['message-list', purows.expanded ? 'isExpanded' : '']">
      <div class="message-card">
        <div class="card-header">
          <span class="icon type_1"></span
          ><span class="msg-title">{{ purows.title }}</span
          ><span class="msg-time">{{ purows.createTime }}</span>
        </div>
        <div class="card-content">
          {{ purows.content }}
        </div>
        <div class="card-footer" @click="handleExpanded">
          {{ purows.expanded ? "收起" : "展开" }}
          <span class="arrow"></span>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
export default {
  name: "MessageRecord",
  props: {
    purows: {},
    index: 0,
  },
  data() {
    return {};
  },

  mounted() {
  },
  computed: {},

  methods: {
    handleExpanded() {
      this.$emit("handleExpanded", this.index);
    },
  },
};
</script>
      <style lang="less" scoped>
.messageRecord {
  .message-list {
    padding: 12px 20px 0 20px;
    .message-card {
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px #eee;
      margin-bottom: 20px;
      padding: 18px;
      .card-header {
        align-items: center;
        display: flex;
        .type_1 {
          background-image: url("@/assets/icons/trumpet.png");
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: contain;
          display: block;
          height: 24px;
          margin-right: 8px;
          width: 24px;
        }
        .msg-title {
          font-size: 14px;
          font-weight: 700;
          margin-right: auto;
        }
        .msg-time {
          color: #bbb;
          font-size: 12px;
        }
      }
      .card-content {
        color: #666;
        font-size: 14px;
        margin: 16px 0;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .card-footer {
        align-items: center;
        color: #999;
        cursor: pointer;
        display: flex;
        font-size: 11px;
        justify-content: flex-end;
        .arrow {
          background-image: url("@/assets/icons/expanded.png");
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: contain;
          display: inline-block;
          height: 12px;
          text-align: right;
          width: 12px;
          transform: rotate(0deg);
        }
      }
    }
  }
  .isExpanded {
    .arrow {
      transform: rotate(180deg) !important;
    }
    .card-content {
      -webkit-line-clamp: initial !important;
      -webkit-box-orient: initial !important;
      overflow: visible !important;
    }
  }
}
</style>